import moment from "moment";

export const calendarCellHeight = 44;
export const calendarBorderWidth = 1;
export const calendarTableWidth = 1026;
export const calendarTimeColumnWidth = 48;

export const calendarMinuteStep = 30;

export const calendarMinDayColumnWidth = (calendarTableWidth - calendarTimeColumnWidth) / 7;

export interface DailyTimeSlots {
  // days of a week, starting Monday
  days: moment.Moment[];
}

// Generates Moment-s for each cell in the calendar Table
// Columns represent days, rows represent start times, which are 30 minute apart.
export const generateDailyTimeSlots = (start: moment.Moment): DailyTimeSlots[] => {
  const timeSlots: DailyTimeSlots[] = [];

  // Iterate on rows, 24 hours day has 48 30 minute time slots
  for (let i = 0; i < 48; i++) {
    const time = start.clone().startOf('day').add(i * calendarMinuteStep, 'minutes');

    // Iterate on days
    const days: moment.Moment[] = [];
    for (let j = 0; j < 7; j++) {
      const day = time.clone().add(j, 'days')
      days.push(day);
    }
    timeSlots.push({days});
  }

  return timeSlots;
}


// WEBPACK FOOTER //
// ./src/event/calendar-utils.ts